<template>
  <div>
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="merchantTypeId == '1' ? 'Tipe Merchant' : 'Tipe Sub Merchant'"
      :valueData="tipeMerchantText(data.account_type)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Jenis QR'"
      :valueData="data.qr_type"
    />
    <data-detail-row
      v-if="isApiSnap"
      :oldValueData="false"
      :data="data"
      :label="'Client Version'"
      :valueData="text(data.client_version)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nomor Rekening'"
      :valueData="data.account_number"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Perusahaan'"
      :valueData="text(data.company_name)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="merchantTypeId == '1' ? 'Nama Merchant' : 'Nama Sub Merchant'"
      :valueData="data.merchant_name"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Pemilik Usaha'"
      :valueData="data.owner_name"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nomor KTP Pemilik Usaha'"
      :valueData="text(data.ktp_no)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="
        accountType == 'Corporate'
          ? 'Nomor NPWP Perusahaan'
          : 'Nomor NPWP Pemilik Usaha'
      "
      :valueData="text(data.npwp_no)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Email'"
      :valueData="data.email"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'No Handphone Pemilik Usaha'"
      :valueData="data.mobile_phone"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="
        merchantTypeId == '1'
          ? 'No Handphone Merchant'
          : 'No Handphone Sub Merchant'
      "
      :valueData="text(data.merchant_mobile_phone)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="
        accountType == 'Corporate' ? 'No Telepon Perusahaan' : 'No Telepon'
      "
      :valueData="merchantPhone == ' ' ? '( not set )' : merchantPhone"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Channel QR'"
      :valueData="data.channel_qr"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Model Usaha'"
      :valueData="data.merchant_model"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Jenis Usaha'"
      :valueData="data.mcc_name"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'MDR On-Us'"
      :valueData="data.mdr_on_us + '%'"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'MDR Off-Us'"
      :valueData="data.mdr_off_us + '%'"
    />
    <!-- Dokumen MDR Khusus -->
    <pdf-detail-api
      v-if="data?.custom_mdr_id"
      :documentId="data.custom_mdr_id"
      :filename="data.custom_mdr_filename"
      :type="isHistory ? 'history' : 'new'"
      label="Dokumen MDR Khusus"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="
        merchantTypeId == '1' ? 'Kriteria Merchant' : 'Kriteria Sub Merchant'
      "
      :valueData="criteriaText(data.merchant_criteria)"
    />
    <data-detail-row
      v-if="data.id_qr_type == '2'"
      :oldValueData="false"
      :data="data"
      :label="'URL Endpoint'"
      :valueData="text(data.endpoint)"
    />
    <data-detail-row
      v-if="data.id_qr_type == '2'"
      :oldValueData="false"
      :data="data"
      :label="'IP Address'"
      :valueData="text(data.ip_address)"
    />
    <!-- SNAP Fields -->
    <data-detail-row
      v-if="isApiSnap"
      :oldValueData="false"
      :data="data"
      :label="'Callback Partner URL Token'"
      :valueData="text(data.access_token_endpoint)"
    />
    <data-detail-row
      v-if="isApiSnap"
      :oldValueData="false"
      :data="data"
      :label="'Callback Partner ID'"
      :valueData="text(data.cred_client_id)"
    />
    <data-detail-row
      v-if="isApiSnap"
      :oldValueData="false"
      :data="data"
      :label="'Client Secret'"
      :valueData="text(data.client_secret)"
    />
    <v-row v-if="isApiSnap" style="align-items: flex-start">
      <v-col cols="10" sm="4">Public Key Partner</v-col>
      <v-col cols="2" sm="1">:</v-col>
      <v-col cols="12" sm="7">
        <div class="public-key-container">
          <v-textarea
            :value="decryptedPublicKey"
            readonly
            outlined
            dense
            rows="4"
            class="fixed-height-textarea"
          />
          <v-btn
            icon
            small
            class="copy-btn"
            @click="copyPublicKey"
            title="Copy Public Key"
          >
            <v-icon small>mdi-content-copy</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="merchantTypeId == '1' ? 'Alamat Merchant' : 'Alamat Sub Merchant'"
      :valueData="data.address"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kota, Kecamatan, Kode Pos'"
      :valueData="
        data.kabupaten_kota + ', ' + data.kecamatan + ', ' + data.kode_pos_id
      "
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'KODE BC/KO'"
      :valueData="text(data.bcko)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Merchant Category Segment'"
      :valueData="text(data.cmer)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Referral Code'"
      :valueData="text(data.referral_code)"
    />
    <data-detail-row
      v-if="isTypeSettlement"
      :oldValueData="oldValue('settlement_type_name') != false"
      :data="data"
      :label="'Type Settlement'"
      :valueData="data.settlement_type_name"
      :oldData="oldValue('settlement_type_name')"
    />
    <data-detail-row
      :oldValueData="oldValue('approver_1') != false"
      :data="data"
      :label="'ID Approver 1'"
      :valueData="data.approver_1"
      :oldData="oldValue('approver_1')"
    />
    <data-detail-row
      :oldValueData="oldValue('approver_2') != false"
      :data="data"
      :label="'ID Approver 2'"
      :valueData="data.approver_2"
      :oldData="oldValue('approver_2')"
    />

    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Additional Data</h3>
      </div>
    </v-card>

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Tempat Lahir Pemilik Usaha'"
      :valueData="text(data.owner_city_of_birth)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Tanggal Lahir Pemilik Usaha'"
      :valueData="text(data.owner_date_of_birth)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Alamat Pemilik Usaha'"
      :valueData="text(data.owner_address)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kode Pos Pemilik Usaha'"
      :valueData="text(data.owner_postal_code)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Pemilik Rekening'"
      :valueData="text(data.account_holder_name)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kantor Cabang Terdekat'"
      :valueData="text(data.bni_branch_office)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Tahun Berdiri'"
      :valueData="text(data.merchant_est_since)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Email Merchant'"
      :valueData="text(data.merchant_email)"
    />

    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Dokumen</h3>
      </div>
    </v-card>

    <div v-if="data.image_ktp">
      <v-row>
        <v-col cols="10" sm="4"> Foto Selfi </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_selfie" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto KTP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_ktp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto Selfi KTP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_selfie_ktp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto TTD </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_tanda_tangan" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto Lokasi Usaha </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_lokasi" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto NPWP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_npwp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto NIB </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <app-pdf-viewer
              :id="$route.params.id"
              :pdfData="data.image_nib"
              pdfType="pdfNib"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'NMID'"
      :valueData="
        data.nmid == '' || data.nmid == null ? '( not set )' : data.nmid
      "
    />
    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>MID</h3>
      </div>
    </v-card>
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'MID'"
      :valueData="data.mid"
    />

    <v-card
      v-if="isCloseMerchant"
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Close Merchant</h3>
      </div>
    </v-card>

    <data-detail-row
      v-if="isCloseMerchant"
      :oldValueData="false"
      :data="data"
      :label="'Kategori Penutupan'"
      :valueData="closedMerchantCategoryLabel"
    />

    <data-detail-row
      v-if="isCloseMerchant"
      :oldValueData="false"
      :data="data"
      :label="'Alasan'"
      :valueData="text(data.reason)"
    />
  </div>
</template>

<script>
import { text } from '../../lib/helpers';
import decryptAES256GCM from '../../lib/utils/decryptAES';
import { dataListMerchantCriteria } from '../../store/params';

export default {
  components: {
    DataDetailRow: () => import('./DataDetailRow.vue'),
    AppPdfViewer: () => import('../form/AppPdfViewer.vue'),
    PdfDetailApi: () => import('../form/PdfDetailApi.vue'),
  },
  props: ['data', 'isHistory'],
  data() {
    return {
      merchant_type: 'Merchant',
      loadingSave: false,
      // qrisFile: null,
      dialog: false,
      dialogReject: false,
      dialogSendback: false,
      loading: false,
      remark: '',
      idTaskAdd: ['0', '2', '3'],
      idTaskEdit: ['4', '5', '6', '14'],
      criteriaMerchantText: dataListMerchantCriteria,
    };
  },
  computed: {
    isCloseMerchant() {
      return this.data != null && this.data.task_type_id.toString() == '7';
    },

    closedMerchantCategoryLabel() {
      const category = this.data?.closed_merchant_category;
      if (category == null || category === '') return text(category);
      const code = this.data?.closed_merchant_code;
      return code ? `${code} - ${category}` : category;
    },

    isTypeSettlement() {
      return this.data != null && this.data.task_type_id.toString() == '15';
    },
    merchantPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    accountType() {
      return this.data != null ? this.data.account_type : null;
    },
    merchantTypeId() {
      if (this.data != null) {
        if (this.data.merchant_type_id != null) {
          return this.data.merchant_type_id;
        }
        return '1';
      }
      return '1';
    },
    isApiSnap() {
      if (this.data == null) return false;
      return this.data.id_qr_type == 2 && this.data.client_version === 'SNAP';
    },
    decryptedPublicKey() {
      if (!this.isApiSnap || !this.data.public_key_inbound) return '';
      try {
        return decryptAES256GCM(this.data.public_key_inbound);
      } catch (e) {
        return this.data.public_key_inbound;
      }
    },
  },
  methods: {
    oldValue(variable) {
      if (
        this.data.old_value != null &&
        this.data.old_value[variable] != null &&
        this.data[variable] != this.data.old_value[variable]
      ) {
        return this.data.old_value[variable];
      }
      return false;
    },
    getOldValue(variable) {
      return this.data.old_value[variable];
    },

    convertMerchantPhone(phoneAreaCode, phone) {
      const area =
        phoneAreaCode != '' && phoneAreaCode != null
          ? `(${phoneAreaCode})`
          : '';
      const phoneText = phone != null ? phone : '';
      return `${area} ${phoneText}`;
    },
    tipeMerchantText(textVal) {
      return textVal.toLowerCase() == 'corporate' ? 'Badan Usaha' : textVal;
    },
    criteriaText(value) {
      const find = this.criteriaMerchantText.find((x) => value == x.value);
      return find != undefined ? find.text : value;
    },
    text,
    copyPublicKey() {
      const textToCopy = this.decryptedPublicKey;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(() => {
          this.$toast.success('Public Key copied to clipboard');
        });
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.$toast.success('Public Key copied to clipboard');
      }
    },
  },
};
</script>

<style scoped>
.fixed-height-textarea {
  font-family: monospace;
  font-size: 12px;
}
.fixed-height-textarea >>> .v-input__slot {
  min-height: 100px !important;
}
.fixed-height-textarea >>> textarea {
  min-height: 80px !important;
  line-height: 1.4;
}
.public-key-container {
  position: relative;
  width: 100%;
}
.copy-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.9);
}
</style>
